<div class="container">
  <div class="header">
    <div class="header-background">
      <img
        src="assets/png/qiagen-top-right-pills.png"
        srcset="
          assets/png/qiagen-top-right-pills.png    1x,
          assets/png/qiagen-top-right-pills@2x.png 2x,
          assets/png/qiagen-top-right-pills@3x.png 3x
        "
        class="absolute top-[14px] right-[33px]"
        width="185"
        height="166"
      />
    </div>
    <gnx-top-nav />
    <div class="header-content">
      <div class="header-extension">
        <div class="back-btn" (click)="location.back()">
          <img src="/assets/svg/blue-back-arrow.svg" />
          <div>Back</div>
        </div>
        <h1>Settings</h1>
      </div>
    </div>
  </div>
  <div class="settings">
    @if (pageLoading) {
      <gnx-dots-loader />
    }
    @if (!pageLoading) {
      <div class="settings-header">
        <gnx-avatar
          class="relative top-[13px] mr-[43px]"
          [bgColor]="'#007da8'"
          [size]="133"
          [textSizeRatio]="2.66"
          textClass="text-white/80 font-light font-[Nunito,sans-serif]"
          [name]="userDetails.name"
        />
        <div class="left-column">
          <h2>{{ userDetails.name }}</h2>
          <p>{{ userDetails.organization.name }}</p>
        </div>
        <div class="right-column">
          <div>
            <strong>{{ variantsCountStore.count() }}</strong>
            <p>Variants Classified</p>
          </div>
        </div>
      </div>
    }
    @if (!pageLoading) {
      <div class="settings-components">
        <mat-tab-group
          [disableRipple]="true"
          [selectedIndex]="selectedTabIndex"
          (selectedIndexChange)="onTabChange($event)"
          #matTabGroup
        >
          <mat-tab label="Profile Details">
            <ng-template matTabContent>
              <gnx-profile-details
                class="tap-content"
                [data]="userDetails"
                [class.overflow-hidden]="matTabGroup.selectedIndex !== 0"
              />
            </ng-template>
          </mat-tab>
          <mat-tab label="Organization Info">
            <ng-template matTabContent>
              <gnx-organization-info
                class="tap-content"
                [isAdmin]="isAdmin"
                [data]="userDetails"
                [class.overflow-hidden]="matTabGroup.selectedIndex !== 1"
              />
            </ng-template>
          </mat-tab>
          <mat-tab label="Members">
            <ng-template matTabContent>
              <gnx-members
                class="tap-content"
                [isAdmin]="isAdmin"
                [data]="userDetails"
                [class.overflow-hidden]="matTabGroup.selectedIndex !== 2"
              />
            </ng-template>
          </mat-tab>
          <mat-tab [disabled]="!showRolesPermissions">
            <ng-template mat-tab-label>
              <span
                matTooltip="Included in Franklin Premium plan, upgrade to enable."
                matTooltipClass="blue-md-tooltip wider"
                [matTooltipDisabled]="showRolesPermissions"
              >
                Roles & Permissions
              </span>
            </ng-template>
            <ng-template matTabContent>
              <gnx-roles-permissions class="tap-content" [isAdmin]="isAdmin" />
            </ng-template>
          </mat-tab>
        </mat-tab-group>
      </div>
    }
  </div>
</div>
